/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function AppleLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00004 255.99998"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M130.66016,29.63136A40.25041,40.25041,0,0,1,168,4a8,8,0,0,1,0,16,24.15408,24.15408,0,0,0-22.4082,15.38037,8.00008,8.00008,0,0,1-14.93164-5.749Zm91.38476,126.12451a40.01719,40.01719,0,0,1-2.73144-69.99951,8.00039,8.00039,0,0,0,2.14111-11.7915A68.012,68.012,0,0,0,128,61.00441,68.00487,68.00487,0,0,0,20,116c0,25.50293,8.33594,52.4668,22.87109,73.97852C57.26514,211.28224,75.63086,224,92,224h72c22.46533,0,47.92578-23.86523,61.916-58.03515A8.00438,8.00438,0,0,0,222.04492,155.75587Z" />
    </Svg>
  );
}

export default AppleLogo;
